import * as React from "react";
import { useRef, useState, useEffect } from "react";
import { CommandBar, ICommandBarItemProps, ICommandBarStyles } from 'office-ui-fabric-react/lib/CommandBar'
import { NavigationResponse } from "../common/model/NavNode";
import constants from "../common/constants";
import { MobileNav } from "./MobileNav";

export function TopNavComponent(props: NavigationResponse) {
    const [, reRender] = useState(0)
    const refs = useRef(props.TopNodes.map(() => null));
    useEffect(() => {
        window.onresize = () => {
            reRender(new Date().getTime());
        };
    }, []);
    if (window.innerWidth <= constants.responsiveWidthThreshold) {
        return (<MobileNav {...props} />);
    }
    const items = props.TopNodes.map((navNode, idx) => {
        const menuItem: ICommandBarItemProps = {
            key: navNode.Id,
            href: navNode.Url,
            text: navNode.Title,
            ariaLabel: navNode.Title,
            className: navNode.IsCurrent ? "isCurrent kofiTopNavNode" : navNode.IsParentOfCurrent ? "isParentOfCurrent kofiTopNavNode" : "kofiTopNavNode",
        }
        if (navNode.SubNodes && navNode.SubNodes.length > 0) {
            menuItem.subMenuProps = {
                items: navNode.SubNodes.map(subNode => {
                    const si: ICommandBarItemProps = {
                        key: subNode.Id,
                        href: subNode.Url,
                        title: subNode.Title,
                        text: subNode.Title,
                        ariaLabel: subNode.Title,
                        className: subNode.IsCurrent ? "isCurrent kofiSubNode" : subNode.IsParentOfCurrent ? "isParentOfCurrent kofiSubNode" : "kofiSubNode",
                    };
                    return si;
                }),
                useTargetAsMinWidth: true,
            }
            menuItem.componentRef = (ref) => refs.current[idx] = ref;
            menuItem.onMouseEnter = () => {
                if (refs.current[idx]) {
                    refs.current[idx]._openMenu();
                    refs.current[idx]._onClick = () => { window.location.href = navNode.Url };
                }
            }
            menuItem.onMouseLeave = () => {
                if (refs.current[idx]) {
                    refs.current[idx]._dismissMenu();
                }
            }
        }
        return menuItem;
    });

    // const itemCount = ;
    const seteStyles: ICommandBarStyles = {
        primarySet: {
            width: (100 / items.length) + "%",
            selectors: {
                ".ms-OverflowSet-item": {
                    width: (100 / items.length) + "%"
                }
            }
        },
    }
    return (<CommandBar
        className="kofiNav kofiTopNav"
        items={items}
        styles={seteStyles}
    />);
}
